module.exports = __webpack_public_path__ + "static/media/promote.33e2fbf8.png";